import React, { useContext, useEffect, useState } from 'react'
import { MusicPlayerContext } from '../../context/MusicPlayerContext'
import { useMusicPlayer } from '../../hooks/useMusicPlayer'
import { getLatestSongsEU, getSonglistURL } from '../../utils/api'
import { Loading } from '../helpers/Loading'
import { getTime } from '../../utils/convert-time'
import { Link } from 'react-router-dom'
import { formatDate, httpToHttps } from '../../utils/helper-functions'
import { SectionHeader } from '../helpers/SectionHeader'
import { RiPauseLine, RiPlayLine, RiVolumeDownLine } from 'react-icons/ri'
import { Box, useColorModeValue } from '@chakra-ui/react'

/**ColumnView: LATEST POPULAR EU TRACKS */
const LatestTracks = () => {
  const [loading, setLoading] = useState( false )
  const [tracks, setTracks] = useState( [] )
  const [state, setState] = useContext( MusicPlayerContext )
  // eslint-disable-next-line
  const { isPlaying, playTrack, currentTrackName } = useMusicPlayer()
  const bg = useColorModeValue( "brand.backgroundLightest", "brand.lighterBlack" )
  const color = useColorModeValue( "brand.textDarkest", "brand.textLight" )

  let id
  let tracksArr = []

  // latest songslist by area
  useEffect( () => {
    async function latestTopSongs() {
      setLoading( true )
      const latestSongs = await getLatestSongsEU()
      let ids = latestSongs.map( id => id.id )
      let urls = await getSonglistURL( ids )
      const songsArray = latestSongs.map( song => {
        urls.map( url => {
          if ( song.id === url.id ) {
            song.url = url.url
            song.id = id
          }
          return url
        } )
        // console.log( song, "song" )
        return song
      } )
      setTracks( songsArray )
      setLoading( false )
    }
    latestTopSongs()
  }, [] )

  // play tracks
  const playCurrentTrack = ( index ) => {
    let current = tracks[index]
    tracksArr = [...state.tracks, current]
    let dedupedArr = [...new Set( tracksArr )]
    let idx = dedupedArr.indexOf( current )
    state.tracks = dedupedArr
    playTrack( idx )
    setState( state => ( { ...state } ) )
  }
  return (
    loading ? <Loading />
      : <div className="latest__root">
        <div className="latest__header">
          <Link to={`/discovery/latest/music`}>
            <SectionHeader
              title="LATEST POPULAR TRACKS"
              icontype="icon" icon="chevron-right"
            />
          </Link>
        </div>
        <Box
          className="latest__trackslist"
          bg={bg}
          color={color}
          paddingTop={1}
        >
          {tracks?.slice( 0, 10 ).map( ( track, index ) => {
            const { name, artists, album, duration, picUrl } = track
            const isActive = track && isPlaying
            // let artistId = artists.length > 1 && artists.map( ( { id } ) => id )
            // console.log( artistId )
            return (
              <div key={track.privilege?.id} className="latest__trackitem">
                <div className="latest__song info">
                  <div className="latest__song--active">
                    {isActive && currentTrackName === name
                      ? <RiVolumeDownLine
                        style={{
                          color: "brand.mainYellow",
                          backgroundColor: "white"
                        }}
                      />
                      : <span>{index + 1}</span>
                    }
                  </div>
                  <div className="latest__song img">
                    <img
                      src={`${`${httpToHttps( picUrl || album.blurPicUrl )}?param=80y80`}`}
                      alt={name}
                      onClick={() => playCurrentTrack( index )}
                    />
                    {currentTrackName === track.name && isPlaying
                      ? <RiPauseLine
                        style={{
                          color: "black",
                          backgroundColor: "white",
                          width: "2.2em",
                          height: "2.2em"
                        }}
                        className="latest__song icon"
                      />
                      : <RiPlayLine
                        style={{
                          color: "black", //doesn't work
                          backgroundColor: "white",
                          width: "2.2em",
                          height: "2.2em"
                        }}
                        className="latest__song icon"
                      />
                    }
                  </div>

                  <div className="latest__song sub-info">
                    <p className={`latest__song title ${isActive && currentTrackName === name ? "latest__song title--active" : ""}`}>
                      {name}
                    </p>
                    <Link to={artists && `/artists/${artists[0]?.id}`}>
                      <span className="latest__song artists">
                        {artists.map( ( { name } ) => name ).join( " & " )}
                      </span>
                    </Link>
                    <br />
                    <span className="latest__song album">
                      {formatDate( album?.publishTime ).slice( 0, 10 )}
                    </span>
                  </div>
                  <span className="latest__song length">
                    {getTime( duration )}
                  </span>
                </div>
              </div>
            )
          } )
          }
        </Box>
      </div>
  )
}
export default LatestTracks